(function ($) {
  $(function () {

    /*****
      Set some global variables
    *****/
    var template_url = $('#template_url').val();


    /*****
      iOS Viewport check
    *****/
    var isVHCheckNeeded = vhCheck();
    var hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
    if (isVHCheckNeeded && hasVHCKeckValue) {
      $('body').addClass('use-ios-offset');
    }


    /*****
      Nav toggle
    *****/
    $('.site-menu-toggle').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
    });


    /*****
      Append a grid-view toggle, but only locally
    *****/
    $('body.is-local').append('<div id="toggle-grid" style="position: fixed; bottom: 10px; left: 10px; cursor: pointer; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); border-radius: 10px; background: white; color: black; font-weight: bold; font-size: 18px; padding: 5px 8px; z-index: 1000;">Grid</div>');
    $(document).on('click', '.is-local #toggle-grid', function (e) {
      e.preventDefault();
      $('body').toggleClass('grid-view');
    });



    /*****
      ScrollReveal
    *****/
    window.sr = ScrollReveal({
      viewOffset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      opacity: 0,
      scale: 1,
      cleanup: false,
      beforeReveal: function (el) {
        el.classList.add('is-animating');
      },
      afterReveal: function (el) {
        el.classList.remove('is-animating');
        el.classList.add('has-animated');
        $(el).removeAttr('data-sr');
        $(el).removeAttr('data-sr-id');
        $(el).removeAttr('style');
      }
    });

    function re_init_scroll_reveal() {
      sr.reveal('[data-sr="fade-slide-down"]', {
        distance: '15px',
        origin: 'top',
        delay: 100,
        duration: 450,
        easing: 'ease'
      });

      sr.reveal('[data-sr="fade-slide"]', {
        distance: '15px',
        origin: 'bottom',
        delay: 100,
        duration: 450,
        easing: 'ease'
      });

      sr.reveal('[data-sr="fade-slide-chain"]', {
        distance: '15px',
        origin: 'bottom',
        delay: 100,
        interval: 50,
        duration: 450
      });
    }

    if ($('[data-sr]').length) {
      re_init_scroll_reveal();
    }

  });
})(jQuery);
